/**
 * Centralized timeout and duration constants
 * All values in milliseconds unless otherwise specified
 */

export const TIMEOUTS = {
  // API Request Timeouts
  API: {
    DEFAULT: 30_000, // 30 seconds
    UPLOAD: 300_000, // 5 minutes for file uploads
    ANALYSIS: 1_200_000, // 20 minutes for AI analysis
    LONG_RUNNING: 600_000, // 10 minutes
  },

  // Cache Durations (for React Query)
  CACHE: {
    // Stale times (when data becomes stale and refetch is triggered)
    STALE: {
      FAST: 60_000, // 1 minute - frequently changing data
      STANDARD: 300_000, // 5 minutes - standard cache
      MEDIUM: 600_000, // 10 minutes - moderately stable data
      LONG: 1_800_000, // 30 minutes - stable data (avatars, etc.)
    },

    // Garbage collection times for cached data
    GC: {
      SHORT: 120_000, // 2 minutes
      STANDARD: 300_000, // 5 minutes
      MEDIUM: 600_000, // 10 minutes
      LONG: 1_800_000, // 30 minutes
    },
  },

  // Test Timeouts
  TEST: {
    DEFAULT: 5000, // 5 seconds
    MEDIUM: 10_000, // 10 seconds
    LONG: 15_000, // 15 seconds
  },

  // Event Source and WebSocket
  REALTIME: {
    CONNECTION_TIMEOUT: 10_000, // 10 seconds to establish connection
    HEARTBEAT: 30_000, // 30 seconds between heartbeats
    RECONNECT_DELAY: 5000, // 5 seconds before reconnect attempt
  },
} as const;

// Helper functions for common conversions
export const TIME_UTILS = {
  /**
   * Convert minutes to milliseconds
   */
  minutes: (min: number): number => min * 60_000,

  /**
   * Convert seconds to milliseconds
   */
  seconds: (sec: number): number => sec * 1000,

  /**
   * Convert hours to milliseconds
   */
  hours: (hours: number): number => hours * 60 * 60_000,

  /**
   * Convert days to milliseconds
   */
  days: (days: number): number => days * 24 * 60 * 60_000,
} as const;
